import { ChangeEventHandler, CSSProperties } from "react";
import { Dropdown } from "react-bootstrap";

export const getChipStyle = (action: string): CSSProperties => {
  let borderColor = "";
  let textColor = "";

  switch (action.toLowerCase()) {
    case "create":
      borderColor = "#04AA6D";
      textColor = "#04AA6D";
      break;
    case "update":
      borderColor = "#8000FF";
      textColor = "#8000FF";
      break;
    case "delete":
      borderColor = "#fbc02d";
      textColor = "#f57f17";
      break;
    default:
      borderColor = "#757575";
      textColor = "#424242";
      break;
  }

  return {
    display: "inline-block",
    padding: "5px 10px",
    fontSize: "12px",
    borderRadius: "5px",
    color: textColor,
    border: `1px solid ${borderColor}`,
    textAlign: "center",
  };
};

export const getRole = (role: string) => {
  const roleMap: { [key: string]: string } = {
    organization_admin: "Org Admin",
    super_admin: "Super Admin",
    developer: "Developer",
    organization: "Organization",
    agent: "Agent",
    user: "User",
    scheduler: "Scheduler",
    queue: "Queue",
    apiKey: "ApiKey",
    task: "Task",
    agent_admin: "Agent Admin",
    emailConnection: "Email Connection",
    notificationConfiguration: "Notification Configuration",
  };

  return roleMap[role];
};

export const entityList = [
  "auth",
  "agent",
  "apikey",
  "emailConnection",
  "organization",
  "queue",
  "scheduler",
  "task",
  "user",
];

export const actionList = ["other", "create", "update", "delete"];

export const getUserRole = (user: {
  role: string;
  name: string;
  email: string;
  deleted_status: boolean;
}) => {
  let userRole;
  if (user.role === "super_admin") {
    userRole = `${user.email} (Super admin)`;
  } else if (user.role === "organization_admin") {
    userRole = `${user.email} (Org admin)`;
  } else if (user.role === "developer") {
    userRole = `${user.email} (Developer)`;
  } else {
    userRole = `${user.email} (Agent admin)`;
  }
  if (user.deleted_status) {
    userRole += " 🚩";
  }
  return userRole;
};

export type OrganizationT = { _id: string; name: string };

function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function FilterDropdown({
  label,
  items,
  handleOptionChange,
  getItemLabel,
}: {
  label: String;
  items: any;
  handleOptionChange: ChangeEventHandler<HTMLInputElement>;
  getItemLabel?: (item: any) => string;
}) {
  if (items.length === 0) return null;

  return (
    <div className="pad-button">
      <Dropdown>
        <Dropdown.Toggle className="dropdown-org buttons text">
          {label} 𝅍
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-space navbar-collapse">
          {items.map(
            (item: { _id: any; name: any; flag: any }, index: number) => (
              <label
                key={item._id || index}
                className="dropdown-option org-item"
                htmlFor={item._id || item.name || String(item)}
              >
                <input
                  type="checkbox"
                  value={item._id || item.name || String(item)}
                  data-value={item._id || item.name || String(item)}
                  onChange={handleOptionChange}
                  id={item._id || String(index)}
                  className="check-box"
                />{" "}
                {getItemLabel
                  ? getItemLabel(item)
                  : `${capitalizeFirstLetter(item.name || String(item))}${
                      item.flag ? item.flag + " " : ""
                    }`}
              </label>
            )
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
